import { defineComponent, reactive, toRefs, ref, unref, computed } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { ElMessage, ElMessageBox, ElForm } from 'element-plus';
import { deepClone } from "@/utils";
import { getDown, listData, getData, delData, addData, updateData } from "@/api/system1/dict/data";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const formContainer = ref(ElForm);
    const router = useRouter();
    const route = useRoute();
    const lineOptions = ref([]);

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '字典数据';
    });
    const state = reactive({
      searchFormData: [{
        prop: "name",
        label: "字典项名称",
        placeholder: "字典项名称/字典编码",
        type: "text",
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => methods.handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => methods.resetQuery()
      }],
      tableLoading: false,
      saveLoading: false,
      dialogVisible: false,
      title: "添加字典类型",
      multipleSelection: [],
      queryParams: {
        name: ''
      },
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['system:dict:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => methods.handleAdd(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['system:dict:remove'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => methods.handleDel(item)
      }],
      // 请求到的表格数据
      tableData: {
        rows: [],
        total: 0
      },
      tableHeader: [{
        prop: "name",
        label: "字典项名称",
        fixed: false,
        type: "text"
      }, {
        prop: "value",
        label: "字典项键值",
        fixed: false,
        type: "text"
      }, {
        prop: "sort",
        label: "显示排序",
        fixed: false,
        type: "text"
      }, {
        prop: "status",
        label: "状态",
        fixed: false,
        statusList: [{
          label: '启用',
          value: 1
        }, {
          label: '禁用',
          value: 0
        }],
        type: "text"
      }, {
        prop: "operation",
        label: "操作",
        width: "150px",
        fixed: 'right',
        operation: [{
          name: "修改",
          clickFun: row => methods.handleUpdate(row),
          hasPermi: ['system:dict:edit']
        }, {
          name: "删除",
          clickFun: row => methods.handleDel(row),
          hasPermi: ['system:dict:remove']
        }]
      }],
      // 表单校验
      formRules: {
        name: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        sort: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }]
      },
      form: {
        name: "",
        value: "",
        sort: "",
        status: 1
      },
      formData: [{
        prop: "name",
        label: "字典项名称",
        disabled: true,
        placeholder: "请输入字典项名称",
        type: "text",
        isSelect: true,
        span: 24
      }, {
        prop: "value",
        label: "字典项键值",
        placeholder: "请输入字典项键值",
        type: "text",
        isSelect: true,
        span: 24
      }, {
        prop: "sort",
        label: "显示排序",
        placeholder: "请输入显示排序",
        type: "textNum",
        isSelect: true,
        span: 24
      }, {
        prop: "status",
        label: '状态',
        props: {
          label: 'labelName'
        },
        type: "radio",
        options: [{
          label: "1",
          value: 1,
          labelName: '启用'
        }, {
          label: "0",
          labelName: '禁用',
          value: 0
        }],
        span: 24
      }]
    });
    const methods = reactive({
      close() {
        state.form = {
          name: "",
          value: "",
          sort: "",
          status: 1
        };
      },
      handleQuery() {
        methods.getList();
      },
      resetQuery() {
        state.queryParams = {
          name: ''
        }, methods.getList();
      },
      getList() {
        state.tableLoading = true;
        listData({
          dictId: route.query.dictType
        }).then(response => {
          state.tableData.rows = response.data.list;
          state.tableData.total = response.data.total;
          state.tableLoading = false;
        });
      },
      //新增
      handleAdd() {
        state.form = {
          dictId: route.query.dictType,
          name: "",
          value: "",
          sort: "",
          status: 1
        };
        state.dialogVisible = true;
        state.title = "添加字典数据";
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        state.form = {
          ...row
        };
        state.dialogVisible = true;
        state.title = "修改字典数据";
      },
      //表单确定
      submitForm: function () {
        const formRef = unref(formContainer);
        formRef.commonForm.validate(valid => {
          if (valid) {
            state.saveLoading = true;
            if (state.title == "修改字典数据") {
              updateData(state.form).then(response => {
                if (response.code == 0) {
                  ElMessage.success("修改成功");
                  state.saveLoading = false;
                  state.dialogVisible = false;
                  methods.getList();
                }
              }).catch(() => {
                state.saveLoading = false;
              });
            } else if (state.title == "添加字典数据") {
              // 新增
              addData(state.form).then(response => {
                if (response.code == 0) {
                  ElMessage.success("新增成功");
                  state.dialogVisible = false;
                  state.saveLoading = false;
                  methods.resetQuery();
                }
              }).catch(() => {
                state.saveLoading = false;
              });
            }
          }
        });
      },
      //删除
      handleDel(row) {
        if (!row.id && !state.multipleSelection.length) {
          ElMessage.closeAll();
          ElMessage.warning("请至少选择一条数据删除");
          return;
        }
        if (row.id) {
          state.multipleSelection = [];
        }
        state.ids = state.multipleSelection.map(item => item.id);
        let dictCodeIds = row.id || state.ids;
        ElMessageBox.confirm("确定是否删除?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          return delData(dictCodeIds);
        }).then(res => {
          ElMessage.closeAll();
          if (res.code == 0) {
            ElMessage.success("删除成功");
          } else {
            ElMessage.warning(res.message);
          }
          methods.getList();
        }).catch(err => {
          console.log(err);
        });
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      ...toRefs(router),
      formContainer,
      lineOptions,
      tableTitle
    };
  }
});